export default __webpack_public_path__ + "static/media/rotate-icon.0f455a39.svg";